import { combineReducers } from 'redux';

import {
  FETCHING_IMPROVEMENTS,
  FETCHED_IMPROVEMENTS,
} from 'modules/affiliation/actions/improvements.action';

const loading = (state = false, action) => {
  switch (action.type) {
    case FETCHING_IMPROVEMENTS:
      return true;
    case FETCHED_IMPROVEMENTS:
      return false;
    default:
      return state;
  }
};

const improvements = (state = null, action) => {
  switch (action.type) {
    case FETCHED_IMPROVEMENTS:
      return action.payload;
    default:
      return state;
  }
};

export default combineReducers({
  loading,
  improvements,
});
